import {BaseTerms} from "../../../../infrastructure/models/base-terms";

export class EntityMegaHeaderModuleTerms extends BaseTerms {
  TEMPLATE_MODULE_TERM = "template module";
}
